<template>
  <b-container active @click="tabClick(2017)" :id="`water-${year}`">
    <template slot="title">
      {{ "2019".toLowerCase().replace("_", " ") }}
    </template>
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">
      <b-row>
        <b-col cols="9">
          Water Data
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button size="sm" @click="requestDownload()">
            Export Water Data
          </b-button>
        </b-col>
      </b-row>
    </div>
    <ag-grid-vue style="width: 100%; height: 400px"
                 class="ag-theme-balham"
                 :gridOptions="topGridOptions"
                 :columnDefs="columnDefs"
                 :rowData="rowData"
                 :defaultColDef="defaultColDef"
                 :enterMovesDownAfterEdit="true"
                 @grid-ready="onGridReady"
                 @cell-clicked="onCellClicked"
                 @cell-editing-stopped="onCellEditingStopped">
    </ag-grid-vue>
    <ag-grid-vue style="width: 100%; height: 40px;"
                 class="ag-theme-balham"
                 :gridOptions="bottomGridOptions"
                 :headerHeight="0"
                 :columnDefs="bottomColumnDefs"
                 :rowData="bottomDataCalc"
                 :rowStyle="rowStyle"
    ></ag-grid-vue>

  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import Bus from "@/eventBus";
import NumericEditor from "@/numericEditor";
import {roundColumnValue} from "@/MetricUtils";
import {FileUtils} from "@/lib/FileUtils";


const SizeEnum = {
  IR: 'irrigation',
  FR: 'frost',
  O1: 'other',
  O2: 'other2'
};

window.numberParser = function numberParser(params) {
  let parsedNumber = Number(params.newValue);
  return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
};

export default {
  name: "VineyardWaterMetricTable",
  props: {rows: Array, year: String, id: String, groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      metricYearVal: this.year,
      gridApi: null,
      gridColumnApi: null,
      bottomColumnDefs: null,
      columnDefs: null,
      defaultColDef: null,
      pinnedTopRowData: null,
      pinnedBottomRowData: null,
      topGridOptions: null,
      bottomGridOptions: null,
      rowData: this.rows,
      bottomData: [],
      rowStyle: {fontWeight: 'bold'},
      enteredValueDecimalPlaces: 2,
      totalsValueDecimalPlaces: 0,
      metricId: this.id,
      myGroupId: this.groupId,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  mounted() {
    this.gridApi = this.topGridOptions.api;
    this.gridColumnApi = this.topGridOptions.columnApi;
    this.$nextTick(this.sendInitialMetricsUpdate(this.metricYearVal));
  },
  watch: {
    rows: function (newVal, oldVal) {
      this.rowData = newVal;
    },
    year: function (newVal, oldVal) {
      this.metricYearVal = newVal;
    },
    id: function (newVal, oldVal) {
      this.metricId = newVal;
    },
    groupId: function (newVal, oldVal) {
      this.myGroupId = newVal;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: 'Month',
        field: 'month',
        pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year',
        field: 'year',
        pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Gallons Irrigation Water',
        field: 'irrigation',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
      {
        headerName: 'Gallons Frost Water',
        field: 'frost',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
      {
        headerName: 'Gallons Other',
        field: 'other',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
      {
        headerName: 'Gallons Other 2 ',
        field: 'other2',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      }
    ];
    this.bottomColumnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Gallons Irrigation Water',
        field: 'irrigation',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
      {
        headerName: 'Gallons Frost Water',
        field: 'frost',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
      {
        headerName: 'Gallons Other',
        field: 'other',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
      {
        headerName: 'Gallons Other 2 ',
        field: 'other2',
        valueParser: this.numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      }
    ];
    this.bottomData = [
      {
        month: 'Total',
        year: '******',
        irrigation: 0,
        frost: 0,
        other: 0,
        other2: 0
      }
    ];

    this.defaultColDef = {
      editable: true,
      resizable: true
    };

    this.pinnedTopRowData = getPinnedTopData();
    this.pinnedBottomRowData = getPinnedBottomData();

    this.topGridOptions = {alignedGrids: [], suppressHorizontalScroll: true};
    this.bottomGridOptions = {
      alignedGrids: [], enableCellExpressions: true, context: {
        theNumber: 4
      }
    };

    this.frameworkComponents = {
      numericEditor: NumericEditor
    };
    this.topGridOptions.alignedGrids.push(this.bottomGridOptions);
    this.bottomGridOptions.alignedGrids.push(this.topGridOptions);
  },
  computed: {
    bottomDataCalc: function () {
      let self = this;
      let columnNames = [];
      Object.values(SizeEnum).map(key => {
        let result = 0;
        Object.values(self.rowData)
            .forEach(row => {
              result += row[key];
            });
        columnNames.push(result);
      });

      let bottom =
          {
            month: 'Total',
            year: '******',
            irrigation: 0,
            frost: 0,
            other: 0,
            other2: 0
          };
      console.log("Column Names");
      console.log(columnNames);
      if (columnNames.length > 0) {
        bottom = {
          month: "Total",
          year: '******',
          irrigation: columnNames[0],
          frost: columnNames[1],
          other: columnNames[2],
          other2: columnNames[3]
        };
      }

      console.log(bottom);

      return [bottom];
    }
  },
  methods: {
    bottomDataCalcFunc: function (year) {

      let self = this;
      let bottomRowsMap = new Map();
      let columnNames = [];
      Object.values(self.rowData).forEach(row => {
        Object.values(SizeEnum).map(key => {
          let result = 0;
          row.forEach(function (item) {
            result += item[key];
          });
          columnNames.push(result);
        });
        //bottomRowsMap.set(year, columnNames)
      });

      let bottom =
          {
            month: "Total",
            year: '******',
            irrigation: 0,
            frost: 0,
            other: 0,
            other2: 0
          };

      console.log(bottom);

      return [bottom];
    },
    tabClick: function () {
    },
    onBtStopEditing() {
      this.gridApi.stopEditing();

    },
    cellValueChanged() {
      this.bottomGridOptions.api.refreshView();
    },
    onBtStartEditing(key, char, pinned) {
      this.gridApi.setFocusedCell(0, "month", pinned);
      this.gridApi.startEditingCell({
        rowIndex: 0,
        colKey: "month",
        rowPinned: pinned,
        keyPress: key,
        charPress: char
      });
    },
    onBtNextCell() {
      this.gridApi.tabToNextCell();
    },
    onBtPreviousCell() {
      this.gridApi.tabToPreviousCell();
    },
    onBtWhich() {
      let cellDefs = this.gridApi.getEditingCells();
      if (cellDefs.length > 0) {
        var cellDef = cellDefs[0];
        console.log(
            "editing cell is: row = " +
            cellDef.rowIndex +
            ", col = " +
            cellDef.column.getId() +
            ", floating = " +
            cellDef.floating
        );
      } else {
        console.log("no cells are editing");
      }
    },
    onGridReady(params) {

      this.gridApi = this.topGridOptions.api;
      this.gridColumnApi = this.topGridOptions.columnApi;
      const updateData = data => {
        this.rowData = data;
      };
    },
    onCellClicked(event) {
      //console.log('onCellClicked: ' + event.rowIndex + ' ' + event.colDef.field);

    },
    sendInitialMetricsUpdate: function (year) {
      let irrigation = 0;
      let frost = 0;
      let other = 0;
      let other2 = 0;
      if (this.gridApi !== undefined) {
        this.gridApi.forEachNode(function (node) {
          if (node.data["year"] === year) {
            irrigation += Number(node.data[SizeEnum.IR]) || 0;
            frost += Number(node.data[SizeEnum.FR]) || 0;
            other += Number(node.data[SizeEnum.O1]) || 0;
            other2 += Number(node.data[SizeEnum.O2]) || 0;
          }
        });
      }
      console.log("Sending Initial Water Update");
      this.calculateAndEmitWaterTotals(irrigation, frost, other, other2, event);
    },
    calculateAndEmitWaterTotals: function (irrigation, frost, other, other2, event) {
      console.log("Calculating and Emitting Water Totals");
      this.bottomGridOptions.api.getRowNode('0').data["irrigation"] = irrigation;
      this.bottomGridOptions.api.getRowNode('0').data["frost"] = frost;
      this.bottomGridOptions.api.getRowNode('0').data["other"] = other;
      this.bottomGridOptions.api.getRowNode('0').data["other2"] = other2;

      let theGridType = "vineyardWaterGrid";

      let waterEmission = {
        gridType: theGridType,
        irrigation: irrigation,
        frost: frost,
        other: other,
        other2: other2,
        year: Number(this.metricYearVal)
      };
      Bus.$emit('vineyard-water-edited', waterEmission);
      console.log("Emitted Vineyard Water Event");
    },
    calculateAndUpdateTotalsVuex: function (irrigation, frost, other, other2, event) {
      console.log("Calculating and Emitting Water Totals");
      this.bottomGridOptions.api.getRowNode('0').data["irrigation"] = irrigation;
      this.bottomGridOptions.api.getRowNode('0').data["frost"] = frost;
      this.bottomGridOptions.api.getRowNode('0').data["other"] = other;
      this.bottomGridOptions.api.getRowNode('0').data["other2"] = other2;

      let theGridType = "vineyardWaterGrid";

      let waterEmission = {
        gridType: theGridType,
        irrigation: irrigation,
        frost: frost,
        other: other,
        other2: other2,
        year: Number(this.metricYearVal)
      };
      this.$store.commit('irrigation', irrigation);
      this.$store.commit('frost', frost);
      this.$store.commit('other', other);
      this.$store.commit('other2', other2);
      console.log("Updated Vineyard Water Totals to Vuex");
    },
    safeParseNumber: function (node, indexName) {
      let isNotANumber = isNaN(node.data[indexName]);
      //console.log(`Is Not a Number: ${isNotANumber}, Node Value: ${node.data[indexName]} returned Value: ${isNotANumber ? 0 : node.data[indexName]}`);
      return isNotANumber ? 0 : Number(node.data[indexName]);
    },
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/${self.metricYearVal}/water/vineyard`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
    onCellEditingStopped(event) {
      console.log('onCellEditingStopped: ' + event.rowIndex + ' ' + event.colId);
      let self = this;
      console.log(event)
      console.log(event.cellIndex)
      console.log(event.colDef.field)

      //let items: Array<rows> = [];
      let irrigation = 0;
      let frost = 0;
      let other = 0;
      let other2 = 0;
      if (self.gridApi !== undefined) {
        self.gridApi.forEachNode(function (node) {
          if (node.data["year"] === event.data["year"]) {
            irrigation += self.safeParseNumber(node, "irrigation");
            frost += self.safeParseNumber(node, "frost");
            other += self.safeParseNumber(node, "other");
            other2 += self.safeParseNumber(node, "other2");
          }
        });
      }

      this.postUpdateToServer();
      // TODO update the items to be posted here!
      this.calculateAndUpdateTotalsVuex(irrigation, frost, other, other2, event);
      this.bottomGridOptions.api.redrawRows({rowNodes: [this.bottomGridOptions.api.getRowNode('0')]})
    },
    // Post VineyardWaterMetric to Server
    postUpdateToServer: function () {
      let self = this;
      if (self.gridApi !== undefined) {
        let numberOfRows = 0;
        let allPowerMetrics = [];
        let year = {};
        let vineyardWaterMetricsMonth = [];
        self.gridApi.forEachNode(function (node) {
          year = node.data["year"];
          vineyardWaterMetricsMonth.push({
            month: node.data["month"],
            irrigation: self.safeParseNumber(node, "irrigation"),
            frost: self.safeParseNumber(node, "frost"),
            other: self.safeParseNumber(node, "other"),
            other2: self.safeParseNumber(node, "other2"),
          })
        });
        let metricYear = {
          _id: this.metricId,
          year: year,
          groupId: this.myGroupId,
          months: vineyardWaterMetricsMonth
        }
        console.log("Metrics Year");
        console.log(JSON.stringify(metricYear));
        this.$http.put("/metrics/vineyard/water/" + this.metricId, JSON.stringify(metricYear), {
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => {
          console.log(response);
          if (self.metricId === null) {
            self.metricId = response.data;
          }
        }).catch(error => {
          console.log("Error Putting Data");
          console.error(error);
        });
      }
    }
  }
}

function getPinnedTopData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getPinnedBottomData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

/*
function getCharCodeFromEvent(event) {
  event = event || window.event;
  return typeof event.which === "undefined" ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
  return !!/\d/.test(charStr);
}

function isKeyPressedNumeric(event) {
  var charCode = getCharCodeFromEvent(event);
  var charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}*/
</script>

<style scoped>

</style>
